import { AccountStateInterface } from "./types";
import Account from "@/types/app/accounts";


export default {
  
  setModalNewAccountState(state: AccountStateInterface, show: boolean) {
    state.modalNewAccount = show;
  },
  setModalCloneAccountState(state: AccountStateInterface, show: boolean) {
    state.modalCloneAccount = show;
  },
  setModalAccountGroupingState(state: AccountStateInterface, show: boolean) {
    state.modalAccountGrouping = show;
  },
  setModalAccountState(state: AccountStateInterface, show: boolean) {
    state.modalAccount = show;
  },
  setAccountState(
    state: AccountStateInterface,
    account: Account
  ) {
    state.account = account;
  },
  setAccountsState(
    state: AccountStateInterface,
    accounts: Account[]
  ) {
    state.accounts = accounts;
  },
  setAccountSent(state: AccountStateInterface, show: boolean) {
    state.accountSent = show;
  }, 
};
